/* Quick-buy button on product cards: bag icon in the corner opens a size list, picking a size adds it to the cart. */
(function () {
	if (window.__aaQuickBuy) return;
	window.__aaQuickBuy = true;

	var css =
		'.aa-qb__btn{position:absolute;top:10px;right:10px;z-index:12;width:36px;height:36px;border-radius:50%;border:0;background:#fff;color:#1f1e20;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;transition:opacity .2s ease}' +
		'.aa-qb__btn:hover{opacity:.8}' +
		'.aa-qb__btn svg{width:18px;height:18px;display:block}' +
		'.aa-qb__btn svg,.aa-qb__close svg{fill:none!important;background:none!important}' +
		'.aa-qb__shade{position:absolute;inset:0;z-index:12;background:rgba(0,0,0,.25);cursor:default}' +
		'.aa-qb__panel{position:absolute;left:0;right:0;bottom:0;z-index:13;box-sizing:border-box;max-height:100%;overflow:auto;background:#fafafa;color:#1f1e20;padding:14px 18px 8px;font-size:14px;line-height:1.3;letter-spacing:0;text-transform:none;text-align:left;cursor:default}' +
		'.aa-qb__head{display:flex;justify-content:space-between;align-items:center;margin-bottom:4px}' +
		'.aa-qb__close{display:flex;background:none;border:0;padding:6px;margin:-6px;color:inherit;cursor:pointer}' +
		'.aa-qb__close svg{width:14px;height:14px;display:block}' +
		'.aa-qb__row{display:flex;justify-content:space-between;gap:12px;width:100%;background:none;border:0;padding:9px 0;margin:0;font:inherit;color:inherit;letter-spacing:0;text-transform:none;text-align:left;cursor:pointer}' +
		'.aa-qb__row:hover{opacity:.6}' +
		'.aa-qb__row[disabled]{opacity:.35;cursor:not-allowed}' +
		'.aa-qb__msg{padding:9px 0}';
	var style = document.createElement('style');
	style.textContent = css;
	document.head.appendChild(style);

	var BAG = '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path d="M3.5 6.5h13v11h-13z" stroke="currentColor" stroke-width="1.2"/><path d="M7 6.5V5a3 3 0 0 1 6 0v1.5" stroke="currentColor" stroke-width="1.2"/></svg>';
	var CLOSE = '<svg viewBox="0 0 14 14" fill="none" aria-hidden="true" focusable="false"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.2"/></svg>';

	var sv = (document.documentElement.lang || '').toLowerCase().indexOf('sv') === 0;
	var T = sv
		? { add: 'Lägg i varukorgen', choose: 'Välj ', close: 'Stäng', soldOut: 'Slutsåld', loading: 'Laddar…', error: 'Något gick fel. Försök igen.' }
		: { add: 'Add to cart', choose: 'Select ', close: 'Close', soldOut: 'Sold out', loading: 'Loading…', error: 'Something went wrong. Please try again.' };

	var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
	var cache = {};

	function money(cents) {
		var digits = cents % 100 ? 2 : 0;
		try {
			return new Intl.NumberFormat(document.documentElement.lang || 'sv', {
				style: 'currency',
				currency: Shopify.currency.active,
				minimumFractionDigits: digits,
				maximumFractionDigits: digits
			}).format(cents / 100);
		} catch (e) {
			return (cents / 100).toFixed(digits);
		}
	}

	function getProduct(handle) {
		if (!cache[handle]) {
			cache[handle] = fetch(root + 'products/' + handle + '.js').then(function (r) {
				if (!r.ok) throw new Error('HTTP ' + r.status);
				return r.json();
			});
			cache[handle].catch(function () { delete cache[handle]; });
		}
		return cache[handle];
	}

	function closeAll() {
		document.querySelectorAll('.aa-qb__panel, .aa-qb__shade').forEach(function (el) { el.remove(); });
	}

	function addToCart(variantId, onError) {
		var cart = document.querySelector('cart-drawer');
		var fd = new FormData();
		fd.append('id', variantId);
		fd.append('quantity', 1);
		if (cart && cart.getSectionsToRender) {
			fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
			fd.append('sections_url', window.location.pathname);
		}
		var url = (window.routes && window.routes.cart_add_url) || root + 'cart/add';
		return fetch(url, {
			method: 'POST',
			headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
			body: fd
		})
			.then(function (r) { return r.json(); })
			.then(function (res) {
				if (res.status) { onError(res.description || res.message || T.error); return; }
				closeAll();
				if (cart && cart.renderContents) cart.renderContents(res);
				else window.location.href = (window.routes && window.routes.cart_url) || root + 'cart';
			})
			.catch(function () { onError(T.error); });
	}

	function openPanel(inner, handle) {
		closeAll();
		var shade = document.createElement('div');
		shade.className = 'aa-qb__shade';
		var panel = document.createElement('div');
		panel.className = 'aa-qb__panel';
		panel.setAttribute('role', 'dialog');
		panel.innerHTML =
			'<div class="aa-qb__head"><span class="aa-qb__title"></span><button type="button" class="aa-qb__close" aria-label="' + T.close + '">' + CLOSE + '</button></div>' +
			'<div class="aa-qb__list"><div class="aa-qb__msg">' + T.loading + '</div></div>';
		inner.appendChild(shade);
		inner.appendChild(panel);
		var list = panel.querySelector('.aa-qb__list');
		var stop = function (e) { e.preventDefault(); e.stopPropagation(); };
		shade.addEventListener('click', function (e) { stop(e); closeAll(); });
		panel.addEventListener('click', stop);
		panel.querySelector('.aa-qb__close').addEventListener('click', function (e) { stop(e); closeAll(); });

		function showMsg(text) {
			var m = panel.querySelector('.aa-qb__msg') || document.createElement('div');
			m.className = 'aa-qb__msg';
			m.textContent = text;
			list.appendChild(m);
		}

		getProduct(handle)
			.then(function (p) {
				if (!panel.isConnected) return;
				var onlyDefault = p.variants.length === 1;
				var name = p.options && p.options.length === 1 && p.options[0].name ? String(p.options[0].name) : '';
				panel.querySelector('.aa-qb__title').textContent = onlyDefault || !name || name === 'Title' ? T.add : T.choose + name.toLowerCase();
				list.innerHTML = '';
				p.variants.forEach(function (v) {
					var row = document.createElement('button');
					row.type = 'button';
					row.className = 'aa-qb__row';
					var a = document.createElement('span');
					a.textContent = onlyDefault ? p.title : v.title;
					var b = document.createElement('span');
					b.textContent = v.available ? money(v.price) : T.soldOut;
					row.appendChild(a);
					row.appendChild(b);
					if (!v.available) row.disabled = true;
					row.addEventListener('click', function (e) {
						stop(e);
						if (row.disabled) return;
						panel.querySelectorAll('.aa-qb__row').forEach(function (r) { r.disabled = true; });
						addToCart(v.id, function (msg) {
							panel.querySelectorAll('.aa-qb__row').forEach(function (r, i) { r.disabled = !p.variants[i].available; });
							showMsg(msg);
						});
					});
					list.appendChild(row);
				});
			})
			.catch(function () { list.innerHTML = ''; showMsg(T.error); });
	}

	function enhance(card) {
		if (card.dataset.aaQb) return;
		var handle = card.dataset.product;
		var inner = card.querySelector('.card__inner');
		if (!handle || !inner) return;
		card.dataset.aaQb = '1';
		var btn = document.createElement('button');
		btn.type = 'button';
		btn.className = 'aa-qb__btn';
		btn.setAttribute('aria-label', T.add);
		btn.innerHTML = BAG;
		btn.addEventListener('click', function (e) {
			e.preventDefault();
			e.stopPropagation();
			if (inner.querySelector('.aa-qb__panel')) closeAll();
			else openPanel(inner, handle);
		});
		inner.appendChild(btn);
	}

	function scan() {
		document.querySelectorAll('.product-card[data-product]').forEach(enhance);
	}

	var timer;
	new MutationObserver(function () {
		clearTimeout(timer);
		timer = setTimeout(scan, 150);
	}).observe(document.documentElement, { childList: true, subtree: true });
	document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
	else scan();
})();
